import { schemes, UserAccountType } from "@zeal/common";
import { z } from "zod";

export const postGeneratePaystubLinkSchema = z.object({
  allow_retry: z.boolean().optional(),
  companyID: schemes.companyID(),
  connectionID: schemes.mongoOrUuid(),
  send_to_worker: z.boolean().optional(),
  workerID: schemes.mongoObjectId(),
  workerType: z.union([
    z.literal(UserAccountType.CompanyContractor),
    z.literal(UserAccountType.CompanyWorker),
  ]),
});

export type TPostGeneratePaystubLinkRequest = z.infer<
  typeof postGeneratePaystubLinkSchema
>;
